"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Code = void 0;
var Code;
(function (Code) {
    // Letters
    Code["KeyA"] = "KeyA";
    Code["KeyB"] = "KeyB";
    Code["KeyC"] = "KeyC";
    Code["KeyD"] = "KeyD";
    Code["KeyE"] = "KeyE";
    Code["KeyF"] = "KeyF";
    Code["KeyG"] = "KeyG";
    Code["KeyH"] = "KeyH";
    Code["KeyI"] = "KeyI";
    Code["KeyJ"] = "KeyJ";
    Code["KeyK"] = "KeyK";
    Code["KeyL"] = "KeyL";
    Code["KeyM"] = "KeyM";
    Code["KeyN"] = "KeyN";
    Code["KeyO"] = "KeyO";
    Code["KeyP"] = "KeyP";
    Code["KeyQ"] = "KeyQ";
    Code["KeyR"] = "KeyR";
    Code["KeyS"] = "KeyS";
    Code["KeyT"] = "KeyT";
    Code["KeyU"] = "KeyU";
    Code["KeyV"] = "KeyV";
    Code["KeyW"] = "KeyW";
    Code["KeyX"] = "KeyX";
    Code["KeyY"] = "KeyY";
    Code["KeyZ"] = "KeyZ";
    // Numbers
    Code["Digit0"] = "Digit0";
    Code["Digit1"] = "Digit1";
    Code["Digit2"] = "Digit2";
    Code["Digit3"] = "Digit3";
    Code["Digit4"] = "Digit4";
    Code["Digit5"] = "Digit5";
    Code["Digit6"] = "Digit6";
    Code["Digit7"] = "Digit7";
    Code["Digit8"] = "Digit8";
    Code["Digit9"] = "Digit9";
    // Common keys
    Code["Enter"] = "Enter";
    Code["Escape"] = "Escape";
    Code["Backspace"] = "Backspace";
    Code["Tab"] = "Tab";
    Code["Space"] = "Space";
    Code["Minus"] = "Minus";
    Code["Equal"] = "Equal";
    Code["BracketLeft"] = "BracketLeft";
    Code["BracketRight"] = "BracketRight";
    Code["Backslash"] = "Backslash";
    Code["Semicolon"] = "Semicolon";
    Code["Quote"] = "Quote";
    Code["Comma"] = "Comma";
    Code["Period"] = "Period";
    Code["Slash"] = "Slash";
    // Function keys
    Code["F1"] = "F1";
    Code["F2"] = "F2";
    Code["F3"] = "F3";
    Code["F4"] = "F4";
    Code["F5"] = "F5";
    Code["F6"] = "F6";
    Code["F7"] = "F7";
    Code["F8"] = "F8";
    Code["F9"] = "F9";
    Code["F10"] = "F10";
    Code["F11"] = "F11";
    Code["F12"] = "F12";
    // Navigation keys
    Code["ArrowUp"] = "ArrowUp";
    Code["ArrowDown"] = "ArrowDown";
    Code["ArrowLeft"] = "ArrowLeft";
    Code["ArrowRight"] = "ArrowRight";
    Code["PageUp"] = "PageUp";
    Code["PageDown"] = "PageDown";
    Code["End"] = "End";
    Code["Home"] = "Home";
    // Numpad keys
    Code["Numpad0"] = "Numpad0";
    Code["Numpad1"] = "Numpad1";
    Code["Numpad2"] = "Numpad2";
    Code["Numpad3"] = "Numpad3";
    Code["Numpad4"] = "Numpad4";
    Code["Numpad5"] = "Numpad5";
    Code["Numpad6"] = "Numpad6";
    Code["Numpad7"] = "Numpad7";
    Code["Numpad8"] = "Numpad8";
    Code["Numpad9"] = "Numpad9";
    Code["NumpadMultiply"] = "NumpadMultiply";
    Code["NumpadAdd"] = "NumpadAdd";
    Code["NumpadEnter"] = "NumpadEnter";
    Code["NumpadSubtract"] = "NumpadSubtract";
    Code["NumpadDecimal"] = "NumpadDecimal";
    Code["NumpadDivide"] = "NumpadDivide";
})(Code || (exports.Code = Code = {}));
//# sourceMappingURL=code.enum.js.map